import { c as _c } from "react/compiler-runtime";
import { InfoCircle } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { Button, DialogTrigger } from 'react-aria-components';
import { Heading, Stack } from 'ui';
import { SaveButton } from '~/components/Common/SaveButton';
import ShareButton from '~/components/Common/ShareButton/src/ShareButton';
import { LoyaltyPriceDisplay } from '~/components/Journey/Loyalty';
import { PricePerPerson } from '~/components/Journey/PricePerPerson';
import useJourneyData from '~/hooks/useJourneyData';
import { useLoyaltyPricing } from '~/hooks/useLoyaltyPricing';
import useTripDisplayTitle from '~/hooks/useTripDisplayTitle';
import { useIsCheckingAvailability } from '~/stores/journeyStore';
import { Popover } from '../../Popover';
import styles from './PriceBar.module.css';
import { PriceDetails } from './PriceDetails';
const PriceBar = () => {
  const $ = _c(22);
  const {
    details,
    futurePricingTiers,
    urlPath,
    price,
    paxCount,
    roomCount,
    uniqueId
  } = useJourneyData();
  const title = useTripDisplayTitle();
  const {
    hasLoyaltyDiscount
  } = useLoyaltyPricing();
  const t = useTranslations("journey");
  const tAria = useTranslations("aria");
  const tCommon = useTranslations("common");
  const isCheckingAvailability = useIsCheckingAvailability();
  const showSaveShareNav = process.env.NEXT_PUBLIC_FF_TRIP_SAVE_SHARE_NAV === "true";
  const isBlueprintTemplate = urlPath === "journey-template";
  const isEarliestCheapestDate = details.startDate === futurePricingTiers?.cheapestAvailableDate;
  const hasFromPrice = isBlueprintTemplate || isEarliestCheapestDate;
  let t0;
  if ($[0] !== title) {
    t0 = <Heading as="h1" variant="h5">{title}</Heading>;
    $[0] = title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== details.endDate || $[3] !== details.startDate || $[4] !== uniqueId) {
    t1 = showSaveShareNav && <Stack horizontal={true} align="center" spacing={4}><ShareButton iconOnly={true} />{uniqueId && <SaveButton tripId={uniqueId} startDate={details?.startDate} endDate={details?.endDate} iconOnly={true} />}</Stack>;
    $[2] = details.endDate;
    $[3] = details.startDate;
    $[4] = uniqueId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== hasFromPrice || $[7] !== hasLoyaltyDiscount || $[8] !== isCheckingAvailability || $[9] !== paxCount || $[10] !== price || $[11] !== roomCount || $[12] !== t || $[13] !== tAria || $[14] !== tCommon) {
    t2 = !isCheckingAvailability && <p>{hasFromPrice && <span>{tCommon("from")} </span>}<DialogTrigger><Button aria-label={tAria("price_details_view")} className="inline-flex items-center gap-1">{hasLoyaltyDiscount ? <LoyaltyPriceDisplay variant="desktop" /> : <><span className="mr-1"><InfoCircle decorative={true} strokeWidth={2} /></span><span className="mr-1 underline typography-title-5"><PricePerPerson /></span></>}<span> {t("per_person")}</span></Button><Popover hasArrow={true} ariaLabel={tAria("price_details")} maxWidth={380}><PriceDetails price={price} paxCount={paxCount} roomCount={roomCount} /></Popover></DialogTrigger></p>;
    $[6] = hasFromPrice;
    $[7] = hasLoyaltyDiscount;
    $[8] = isCheckingAvailability;
    $[9] = paxCount;
    $[10] = price;
    $[11] = roomCount;
    $[12] = t;
    $[13] = tAria;
    $[14] = tCommon;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== t1 || $[17] !== t2) {
    t3 = <div className={styles.rightGroup}>{t1}{t2}</div>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] !== t0 || $[20] !== t3) {
    t4 = <div className="hidden md:space-y-2 md:mt-4 md:block"><Stack horizontal={true} justify="between" align="center">{t0}{t3}</Stack></div>;
    $[19] = t0;
    $[20] = t3;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  return t4;
};
export { PriceBar };